import ErrorSectionFormatter from './internal/ErrorSectionFormatter';
import HtmlSectionFormatter from './internal/HtmlSectionFormatter';
import { stripHtml } from '../CopilotPreview/internal/utils/Messages';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const UNSUPPORTED_TYPES = ['DATA_TABLE', 'MEDIA', 'THOUGHT', 'ACCORDION', 'CARD', 'IMAGE_GRID', 'MEDIA_V2'];
/** Component only supports displaying plain text and action buttons */
const SimpleMessageSectionDisabled = ({
  section
}) => {
  if (UNSUPPORTED_TYPES.includes(section.type)) {
    return null;
  } else if (section.type === 'HTML' || section.type === 'LLM') {
    return /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-primary-disabled",
        children: /*#__PURE__*/_jsx(HtmlSectionFormatter, {
          section: section
        })
      })
    });
  } else if (section.type === 'PLAIN_TEXT') {
    const plainText = stripHtml(section.text);
    return /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-primary-disabled",
      children: plainText
    });
  } else if (section.type === 'ACTION') {
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorSectionFormatter, {});
};
export default SimpleMessageSectionDisabled;